import CityPageTemplate from "../city-template/CityPageTemplate";
import { englewoodCoConfig } from "./data";

export default function EnglewoodCoPage() {
  return <CityPageTemplate config={englewoodCoConfig} />;
}